var angular = require('angular')

angular.module('AemBranchesAppointments')
  .component('appointmentBranchHeader', {
    template: require('./appointment-branch-header.component.tpl.html'),
    controller: AppointmentBranchHeaderCtrl,
    controllerAs: 'vm',
    bindings: {
      branch: '<'
    }
  })

AppointmentBranchHeaderCtrl.$inject = ['wgService', 'i18n', '$routeParams', 'userTracking']

function AppointmentBranchHeaderCtrl (wgService, i18n, $routeParams, userTracking) {
  var vm = this

  vm.$onInit = function () {
    vm.toDetail = toDetail
  }

  vm.$onChanges = function (changesObj) {
    if (changesObj.branch.currentValue && wgService.getParams().branchDetailUrl) {
      vm.branchDetailUrl = wgService.getParams().branchDetailUrl[i18n.langCode].replace('%{id}', vm.branch.id) || null
    }
  }

  function toDetail () {
    if ($routeParams.timeSlot) {
      // from appointment-create
      userTracking.onClick('detailBranch', 'lead')
    } else {
      // from appointment-select
      userTracking.onClick('detailBranch', 'reservation')
    }
  }
}
